import { render, staticRenderFns } from "./item.vue?vue&type=template&id=8c94efc8&scoped=true&"
import script from "./item.vue?vue&type=script&lang=ts&"
export * from "./item.vue?vue&type=script&lang=ts&"
import style0 from "./item.vue?vue&type=style&index=0&id=8c94efc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c94efc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c94efc8')) {
      api.createRecord('8c94efc8', component.options)
    } else {
      api.reload('8c94efc8', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=8c94efc8&scoped=true&", function () {
      api.rerender('8c94efc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/menu-blocks/item.vue"
export default component.exports